import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import {
  ModalContent,
  Title,
  ButtonArea,
  Button
} from "./styles";

import "~/components/styles/Global.css";
import "~/components/styles/Contracts.css";
import { verifyRoles } from '~/utils/functions/verifyRoles';

export default function CompetitiveTraining({
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const roles = useSelector(state => state.rolesReducer.roles);
  const traingingReducer = useSelector(state => state.trainingReducer);

  const [modalOpen, setModalOpen] = useState(traingingReducer.openModalHome);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };
  const parameters = {
    headers: header,
  };

  useEffect(() => {
    setModalOpen(traingingReducer.openModalHome)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [traingingReducer.openModalHome]);

  useEffect(() => {
    hasTrainingComplicance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function hasAceptedTermsLGPDNps() {
    const privacyPolicy = localStorage.getItem('privacyPolicyFirst');
    const lgpd = localStorage.getItem('lgpd');
    if (privacyPolicy === 'true' && lgpd === 'true') {
      return true
    }
    return false;
  }

  function hasTrainingComplicance() {
    const competitiveCompliance = localStorage.getItem('competitiveCompliance');
    if (hasAceptedTermsLGPDNps() && competitiveCompliance !== 'true' ) {
      setModalOpen(true);
    }
  }

  function handleVideo() {
    localStorage.setItem('competitiveCompliance', true)
    dispatch({ type: 'SET_MODAL_HOME', openModalHome: false });
    history.push(`/universidade-ultragaz#/trilhas/video-player/${process.env.REACT_APP_COMPETITIVE_VIDEO_CODE}`);
  }

  return (
    verifyRoles(roles, 'TREINAMENTOS') ? (
      <Modal
      show={modalOpen}
      onHide={() => {
        setModalOpen(true);
      }}
      className="modal-contrato"
      centered={true}
      scrollable={false}
      size="lg"
    >
      <Modal.Body scrollable={false} style={{
        overflow: "hidden",
        padding: ".5rem",
        borderRadius: 15
      }}>
        {
          <ModalContent>
            <Title>
              <span>Treinamento concorrencial</span>
            </Title>
            <p>
              Olá, Verificamos que você ainda não realizou o treinamento de <b>Compliance Concorrencial</b>. Clique no botão abaixo para realizá-lo agora.
            </p>
            <ButtonArea>
              <Button
                onClick={() => handleVideo()}
              >
                Realizar treinamento
              </Button>
            </ButtonArea>
          </ModalContent>
        }
      </Modal.Body>
    </Modal>
    ) : (
      <>
      </>
    )
  );
}
